import { Grid } from "@material-ui/core";
import React, { useEffect } from "react";
import { useForm } from "../useForm";
import Controls from "../controls/Controls";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { FormsRef } from "../formsRef";

const initialFValues = {
  id: 0,
  title: "",
  titleENG: "",
  subtitle: "",
  subtitleENG: "",
};

const ProgramForm = (props) => {
  const { upload, showModal, handleClose, pageTitle, carry } = props;
  const { title, titleENG, subtitle, subtitleENG } = FormsRef();
  const { values, setValues, handleInputChange, resetForm } =
    useForm(initialFValues);

  const handleSubmit = (e) => {
    e.preventDefault();
    upload({
      id: carry.id,
      title: title.current.value,
      titleENG: titleENG.current.value,
      subtitle: subtitle.current.value,
      subtitleENG: subtitleENG.current.value,
    });
  };

  return (
    <Modal show={showModal} onHide={handleClose} size="lg">
      <Modal.Header>
        <Modal.Title>{pageTitle}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <Form.Group className="mb-3">
                <Form.Label>Title</Form.Label>
                <Form.Control ref={title} defaultValue={carry.title || ""} />
              </Form.Group>{" "}
              <Form.Group className="mb-3">
                <Form.Label>Subtitle</Form.Label>
                <Form.Control
                  ref={subtitle}
                  defaultValue={carry.subtitle || ""}
                />
              </Form.Group>
            </Grid>
            <Grid item xs={6}>
              <Form.Group className="mb-3">
                <Form.Label>TitleENG</Form.Label>
                <Form.Control
                  ref={titleENG}
                  defaultValue={carry.titleENG || ""}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>SubtitleENG</Form.Label>
                <Form.Control
                  ref={subtitleENG}
                  defaultValue={carry.subtitleENG || ""}
                />
              </Form.Group>
            </Grid>
          </Grid>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Bezárás
        </Button>
        <Button variant="primary" onClick={handleSubmit} type="submit">
          Mentés
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ProgramForm;
